module.exports = __webpack_public_path__ + "img/cl.8949f9e6.svg";